import { Link } from 'react-router-dom'

import moment from 'moment'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import { employeeUser } from 'modules/core/store/collections/users'

import type CalendarEvent from 'modules/calendar/store/models/CalendarEvent'
import employees from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'

import styles from './index.module.scss'

interface Props {
  event: CalendarEvent
  employeeId: number
  withDates: boolean
}

const EmployeeEvent = ({ event, employeeId, withDates }: Props) => {
  const { navigation } = useNavigation()

  const getName = (employee: Employee): string => {
    const name = employeeUser(employee).fullName()
    if (withDates) {
      const day = moment(event.attributes.date).format('dddd')
      return i18n.t('calendar.event_date_with_name', {
        name,
        day,
      })
    } else {
      return name
    }
  }

  const employee = employees.get(employeeId)

  if (!employee) return null

  if (!employee.policy.can('readLeaves')) {
    return (
      <div className={styles.item}>
        <span>{getName(employee)}</span>
      </div>
    )
  }

  const to = navigation.employees.id.timeOff.fullPath({ id: employee.attributes.id })

  return (
    <Link to={to} className={styles.link}>
      <span>{getName(employee)}</span>
    </Link>
  )
}

export default observer(EmployeeEvent)
